export let unreadPivotAriaLabel = "Ss8FX";
export default {unreadPivotAriaLabel};